exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes circleAnimationProgress {\n  from {stroke-dashoffset: 0px;}\n  to {stroke-dashoffset: -230px}\n}\n.circleAnimationProgress {\n  stroke-dashoffset: 0;\n  stroke-dasharray: 230;\n  animation-timing-function: linear;\n  transform: rotate(-90deg);\n  transform-origin: center;\n}\n", ""]);

// exports
